export default __webpack_public_path__ + "static/media/logo.a01cbf68.svg";